import type { ThemeConfig } from 'antd';

/** Cursor-style dark palette: deep charcoal surfaces, muted steel accent. */
export const darkAntTheme: ThemeConfig = {
    token: {
        colorBgBase: '#141414',
        colorTextBase: '#ececec',
        colorBgContainer: '#1a1a1a',
        colorBgElevated: '#252525',
        colorBgLayout: '#0f0f0f',
        colorBorder: '#2a2a2a',
        colorBorderSecondary: '#242424',
        colorSplit: '#2a2a2a',
        colorText: '#ececec',
        colorTextSecondary: '#9b9b9b',
        colorTextTertiary: '#737373',
        colorTextQuaternary: '#5c5c5c',
        colorPrimary: '#7a9bb5',
        colorPrimaryHover: '#8aa8c0',
        colorPrimaryActive: '#6a8da8',
        colorPrimaryBg: 'rgba(122, 155, 181, 0.12)',
        colorPrimaryBorder: '#5f8199',
        colorLink: '#9eb3c7',
        colorLinkHover: '#b4c4d4',
        colorInfo: '#7a9bb5',
        colorFill: 'rgba(255, 255, 255, 0.06)',
        colorFillSecondary: '#252525',
        colorFillTertiary: '#1f1f1f',
        colorFillQuaternary: '#1a1a1a',
        colorBgTextHover: 'rgba(255, 255, 255, 0.06)',
        colorBgTextActive: 'rgba(255, 255, 255, 0.1)',
        borderRadius: 10,
        borderRadiusLG: 12,
        borderRadiusSM: 8,
        colorError: '#e07070',
        colorWarning: '#c9a227',
        colorSuccess: '#6fad6f',
    },
    components: {
        Menu: {
            itemBorderRadius: 8,
            itemMarginInline: 8,
            itemSelectedBg: '#252525',
            itemSelectedColor: '#ececec',
            itemHoverBg: 'rgba(255, 255, 255, 0.06)',
            subMenuItemBg: 'transparent',
        },
        Button: {
            primaryShadow: 'none',
            defaultShadow: 'none',
        },
        Card: {
            borderRadiusLG: 12,
        },
        Modal: {
            borderRadiusLG: 12,
        },
        Tabs: {
            itemSelectedColor: '#ececec',
            inkBarColor: '#7a9bb5',
        },
        Input: {
            activeBorderColor: '#5f8199',
            hoverBorderColor: '#3a3a3a',
        },
        Select: {
            optionSelectedBg: 'rgba(122, 155, 181, 0.15)',
        },
        Table: {
            borderRadius: 10,
            headerBorderRadius: 10,
        },
        Segmented: {
            itemSelectedBg: '#252525',
            trackBg: '#1a1a1a',
        },
    },
};

/** ProLayout header/sider menu tokens — keeps top bar + "..." overflow readable in dark mode */
export const darkProLayoutToken = {
    bgLayout: '#0f0f0f',
    header: {
        heightLayoutHeader: 56,
        colorBgHeader: '#141414',
        colorHeaderTitle: '#ececec',
        colorTextMenu: '#9b9b9b',
        colorTextMenuSecondary: '#737373',
        colorTextMenuSelected: '#ececec',
        colorTextMenuActive: '#ececec',
        colorBgMenuItemSelected: '#252525',
        colorBgMenuItemHover: 'rgba(255, 255, 255, 0.06)',
        colorTextRightActionsItem: '#9b9b9b',
    },
    sider: {
        colorMenuBackground: '#141414',
        colorTextMenu: '#9b9b9b',
        colorTextMenuSelected: '#ececec',
        colorTextMenuActive: '#ececec',
        colorBgMenuItemSelected: '#252525',
        colorBgMenuItemHover: 'rgba(255, 255, 255, 0.06)',
    },
};
